<div id="shop-list-title">
	<h3 class="shop-list-title-when-shops shop-list-title-hidden">Magazinele Orange aflate &#238;n aria delimitat&#259; de hart&#259;</h3>
	<h3 class="shop-list-title-when-no-shops shop-list-title-hidden">Navigheaz&#259; pe hart&#259; sau folose&#x219;te op&#539;iunile de c&#259;utare pentru a g&#259;si magazinul dorit</h3>
</div>
